module.exports = __webpack_public_path__ + "media/images/story/top/step_arrow-5d0fa2253017e282d85329fe1375b7b7.svg";